
import { message, appStore, company } from 'kts-platform-frame/api';
import { Response } from 'kts-scaffold-framework/server';
import { history } from 'kts-platform-frame/routes';

/** 切换公司 */
export default async function switchCompany(companyId: string) {
    
    // 切换公司
    const data = await company.switching(window, { companyId });
    if (data.er) {
        return data;
    }

    // 获取用户数据
    const userInfo = await company.userInfo(window);
    if (userInfo.er) {
        return data;
    }

    // 更新了未读消息数
    const messageCountUnread = await message.messageCountUnread(window);
    if (messageCountUnread.er) {
        return data;
    }

    // 获取菜单APP列表
    const queryMenuApp = await appStore.queryMenuApp(window);
    if (queryMenuApp.er) {
        return data;
    }

    window.location.href = `/workbench/m/Kingxunlian.AppStore/?routing=list%2Fmyapp`;
    // window.location.href = `/workbench/m/Kingxunlian.AppStore`;
    return new Response(null);
}


// WEBPACK FOOTER //
// ./src/node_modules/kts-platform-frame/appSdk/switchCompany/index.tsx